import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../../stores/useAuthStore';
import { useLoadingStore } from '../../stores/useLoadingStore';
import { useTripAnalysisSubscriptionStore } from '../../stores/analysis/useTripAnalysisSubscriptionStore';

const { stopLoading } = useLoadingStore.getState();

export function useGuestGuard() {
    
    const navigate = useNavigate();

    const user = useAuthStore(state => state.user);

    const isGuest = user === null;

    useEffect(() => {

        useTripAnalysisSubscriptionStore
            .getState()
            .clearSubscriptions();

        if (!isGuest) {
            navigate('/', {replace: true});
        }

        stopLoading(false);

    }, [
        isGuest,
        navigate
    ]);

    return {
        isGuest
    };

}